export async function fetchAdminHealth() {
  const res = await fetch('/api/admin/health/services');
  if (!res.ok) {
    throw new Error('Erreur récupération état des services');
  }
  return await res.json();
}